import { IObject } from "@quest/base-core";

export let eventDispatchers: IObject = {
  SHOW_POSTLOADING_VIEW: "SHOW_POSTLOADING_VIEW",
  CHECK_RESIZE: "CHECK_RESIZE",
  // CaseCade Game Events
  PARSE_NEXT_CASCADE_DATA: "PARSE_NEXT_CASCADE_DATA",
  SHOW_SYM_WIN: "SHOW_SYM_WIN",
  ON_CASCADE_REELS: "ON_CASCADE_REELS",
  CASCADE_SPIN_COMPLETE: "CASCADE_SPIN_COMPLETE",
  SHOW_CASCADE_WIN: "SHOW_CASCADE_WIN",
  START_NEXT_CASCADE: "START_NEXT_CASCADE",
  BURST_SYMBOLS: "BURST_SYMBOLS",
  BURST_SYMBOLS_DESTROY: "BURST_SYMBOLS_DESTROY",
  START_NEXT_LINE_TOGGLE: "START_NEXT_LINE_TOGGLE",

  ON_CASCADE: "ON_CASCADE",
  ON_CASCADE_COMPLETE: "ON_CASCADE_COMPLETE",
  RESET_FS_PROGRESS_BAR: "RESET_FS_PROGRESS_BAR",
  ADD_STICKY_FRMAES: "ADD_STICKY_FRMAES",
  HIDE_STICKY_FRAMES_CONTAINER: "HIDE_STICKY_FRAMES_CONTAINER",
  ADD_STICKY_FRMAES_FG: "ADD_STICKY_FRMAES_FG",
  HIDE_STICKY_FRAMES_CONTAINER_FG: "HIDE_STICKY_FRAMES_CONTAINER_FG",
  //basegame : special symbol meter
  SPECIAL_SYMBOL_OUT_ANIM: "SPECIAL_SYMBOL_OUT_ANIM",
  SPECIAL_SYMBOL_OUT_ANIM_FG: "SPECIAL_SYMBOL_OUT_ANIM_FG",
  // BASE GAME : FREE SPINS PROGRESS BAR
  ON_CASCADE_UPDATE_FS_BAR: "ON_CASCADE_UPDATE_FS_BAR",
  ON_CASCADE_COMPLETE_UPDATE_FS_BAR: "ON_CASCADE_COMPLETE_UPDATE_FS_BAR",
  RESET_FS_BAR: "RESET_FS_BAR",

  // FREE GAME : RETRIGGER FREE SPINS PROGRESS BAR
  ON_CASCADE_UPDATE_FS_BAR_RETRIGGER: "ON_CASCADE_UPDATE_FS_BAR_RETRIGGER",
  ON_CASCADE_COMPLETE_UPDATE_FS_BAR_RETRIGGER: "ON_CASCADE_COMPLETE_UPDATE_FS_BAR_RETRIGGER",
  RESET_FS_BAR_RETRIGGER: "RESET_FS_BAR_RETRIGGER",
  HIDE_INVESTIGATION_BACKGROUND: "HIDE_INVESTIGATION_BACKGROUND",
  // Cascade FG Events
  SHOW_FG_SYM_WIN: "SHOW_FG_SYM_WIN",
  FG_CASCADE_SPIN_COMPLETE: "FG_CASCADE_SPIN_COMPLETE",
  FG_BURST_SYMBOLS: "FG_BURST_SYMBOLS",
  FG_BURST_SYMBOLS_DESTROY: "FG_BURST_SYMBOLS_DESTROY",

  // Free Game Reel Set
  UDPATE_NEW_FG_REELSET: "UDPATE_NEW_FG_REELSET",

  // Base game stack symbol
  START_STACK_SYMBOL_WIN_ANIMATION: "START_STACK_SYMBOL_WIN_ANIMATION",
  HIDE_STACK_SYMBOL_WIN_ANIMATION: "HIDE_STACK_SYMBOL_WIN_ANIMATION",
  INITIALIZE_STACK_SYMBOL_WIN: "INITIALIZE_STACK_SYMBOL_WIN",

  // Free game stack symbol
  START_FG_STACK_SYMBOL_WIN_ANIMATION: "START_FG_STACK_SYMBOL_WIN_ANIMATION",
  HIDE_FG_STACK_SYMBOL_WIN_ANIMATION: "HIDE_FG_STACK_SYMBOL_WIN_ANIMATION",
  INITIALIZE_FG_STACK_SYMBOL_WIN: "INITIALIZE_FG_STACK_SYMBOL_WIN",

  // Bg cluster win frame
  INITIALIZE_CLUSTER_WIN_FRAME: "INITIALIZE_CLUSTER_WIN_FRAME",
  SHOW_CLUSTER_WIN_FRAME: "SHOW_CLUSTER_WIN_FRAME",
  HIDE_CLUSTER_WIN_FRAME: "HIDE_CLUSTER_WIN_FRAME",

  // Fg cluster win frame
  INITIALIZE_FG_CLUSTER_WIN_FRAME: "INITIALIZE_FG_CLUSTER_WIN_FRAME",
  SHOW_FG_CLUSTER_WIN_FRAME: "SHOW_FG_CLUSTER_WIN_FRAME",
  HIDE_FG_CLUSTER_WIN_FRAME: "HIDE_FG_CLUSTER_WIN_FRAME",

  //Win Sequence
  ON_SHOW_NEXT_PRESENTATION: "ON_SHOW_NEXT_PRESENTATION",

  //Trail Animation
  START_SCATTER_TRAIL: "START_SCATTER_TRAIL",
  START_SCATTER_TRAIL_FG: "START_SCATTER_TRAIL_FG",

  //big win
  SHOW_POP_UP_BLUR_BG: "SHOW_POP_UP_BLUR_BG",

  SHOW_ROOM_AFTER_BANNER: "SHOW_ROOM_AFTER_BANNER",
  CLUE_REWARD_MSG_BANNER: "CLUE_REWARD_MSG_BANNER",
  //Meter Update
  UPDATE_METER_VALUES: "UPDATE_METER_VALUES",
  UPDATE_METER_VALUES_FG: "UPDATE_METER_VALUES_FG",
  SHOW_FS_BAR_WIN: "SHOW_FS_BAR_WIN",
  SHOW_FS_BAR_WIN_FG: "SHOW_FS_BAR_WIN_FG",
  UPDATE_METER_LIMITS: "UPDATE_METER_LIMITS",

  SHOW_QL_PLAYER_MESSAGE: "SHOW_QL_PLAYER_MESSAGE",
  FORCE_STOP_QL_PLAYER_MESSAGE: "FORCE_STOP_QL_PLAYER_MESSAGE",
  FG_SHOW_QL_PLAYER_MESSAGE: "FG_SHOW_QL_PLAYER_MESSAGE",
  FG_FORCE_STOP_QL_PLAYER_MESSAGE: "FG_FORCE_STOP_QL_PLAYER_MESSAGE",
  //Banner Screen

  DISPLAY_BANNER_SCREEN: "DISPLAY_BANNER_SCREEN",

  //investingation room
  SHOW_INVESTINGATION_ROOM: "SHOW_INVESTINGATION_ROOM",
  HIDE_INVESTINGATION_ROOM: "HIDE_INVESTINGATION_ROOM",
  HIDE_BASEGAME_REEL: "HIDE_BASEGAME_REEL",
  DISABLE_BOARD_BUTTONS: "DISABLE_BOARD_BUTTONS",

  //INVESTIGATION OUTRO BANNER
  SHOW_JACKPOT_BANNER: "SHOW_JACKPOT_BANNER",
  SHOW_GRAND_BANNER: "SHOW_GRAND_BANNER",
  INITIALIZE_CLUE_BANNER: "INITIALIZE_CLUE_BANNER",
  INITIALIZE_GRAND_CLUE_BANNER: "INITIALIZE_GRAND_CLUE_BANNER",

  //money huning feature
  START_MONEY_HUNTING_FEATURE: "START_MONEY_HUNTING_FEATURE",
  START_MONEY_HUNTING_FEATURE_FG: "START_MONEY_HUNTING_FEATURE_FG",
  SHOW_STICKY_SYMBOL_VALUES: "SHOW_STICKY_SYMBOL_VALUES",
  ADD_LIGHTNING_VIEW_ON_TOP: "ADD_LIGHTNING_VIEW_ON_TOP",
  INITIALIZE_WIN_COLLECTION: "INITIALIZE_WIN_COLLECTION",
  RESET_WIN_COLLECTION_COIN_TRAIL: "RESET_WIN_COLLECTION_COIN_TRAIL",
  UPDATE_FINAL_POSITION: "UPDATE_FINAL_POSITION",
  PLAY_WIN_COLLECTION_COIN_TRAIL: "PLAY_WIN_COLLECTION_COIN_TRAIL",
  START_WIN_COLLECTION: "START_WIN_COLLECTION",
  START_WIN_COLLECTION_FG: "START_WIN_COLLECTION_FG",
  PLAY_BLAST_ON_WIN_METER: "PLAY_BLAST_ON_WIN_METER",
  PLAY_BLAST_ON_WIN_METER_FG: "PLAY_BLAST_ON_WIN_METER_FG",
  // UPDATE_TICKUP_WIN_METER: "UPDATE_TICKUP_WIN_METER",
  // UPDATE_TICKUP_WIN_METER_FG: "UPDATE_TICKUP_WIN_METER_FG",
  UPDATE_MONEY_HUNTING_SYMBOL_ON_REEL: "UPDATE_MONEY_HUNTING_SYMBOL_ON_REEL",
  UPDATE_MONEY_HUNTING_SYMBOL_ON_REEL_FG: "UPDATE_MONEY_HUNTING_SYMBOL_ON_REEL_FG",
  PARSE_NEXT_MONEY_HUNT_DATA: "PARSE_NEXT_MONEY_HUNT_DATA",
  HIDE_SYMBOL_ON_REEL: "HIDE_SYMBOL_ON_REEL",
  HIDE_SYMBOL_ON_REEL_FG: "HIDE_SYMBOL_ON_REEL_FG",
  SHOW_OVERLAY: "SHOW_OVERLAY",
  HIDE_OVERLAY: "HIDE_OVERLAY",
  GLOW_ALL_FRAMES: "GLOW_ALL_FRAMES",
  HIDE_MONEY_FEATURE: "HIDE_MONEY_FEATURE",
  TOP_LOGO_HIDE_ON_BIG_WIN_FG: "TOP_LOGO_HIDE_ON_BIG_WIN_FG",
  TOP_LOGO_SHOW_ON_BIG_WIN_FG: "TOP_LOGO_SHOW_ON_BIG_WIN_FG",
  HIDE_TOP_LOGO: "HIDE_TOP_LOGO",
  SHOW_TOP_LOGO: "SHOW_TOP_LOGO",
  HIDE_POP_UP_BLUR_BG: "HIDE_POP_UP_BLUR_BG",
  START_CLUE_REVEAL: "START_CLUE_REVEAL",
  PLAY_REVEALED_CLUE_ANIMATION: "PLAY_REVEALED_CLUE_ANIMATION",
  PLAY_REVEALED_CLUE_ANIMATION_FG: "PLAY_REVEALED_CLUE_ANIMATION_FG",
  START_SUSPECT_REVEAL: "START_SUSPECT_REVEAL",
  RESET_ROOM_AFTER_GRAND: "RESET_ROOM_AFTER_GRAND",
  ALIGN_PROGRESS_BAR: "ALIGN_PROGRESS_BAR",
  ALIGN_PROGRESS_BAR_FG: "ALIGN_PROGRESS_BAR_FG",
  ADD_MSG_BANNER_ON_TOP: "ADD_MSG_BANNER_ON_TOP",



  STOP_WIN_TICK_UP_FG: "STOP_WIN_TICK_UP_FG",
  STOP_WIN_TICK_UP: "STOP_WIN_TICK_UP",
  HIDE_FREEGAME_REEL: "HIDE_FREEGAME_REEL",
  SHOW_FREEGAME_REEL: "SHOW_FREEGAME_REEL",
  
  TOP_LOGO_HIDE: "TOP_LOGO_HIDE",
  TOP_LOGO_SHOW: "TOP_LOGO_SHOW",
  
  HANDLE_BUTTON_AS_PER_MARKET:"HANDLE_BUTTON_AS_PER_MARKET",
};
